module.exports = __webpack_public_path__ + "media/images/front/medical_leaders/hospital_list/img_doctor08-fb99d937232273f2f430defce60925cf.png";